import Forbidden from 'components/pages/Forbidden'

export default Forbidden
